import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export function CheckoutLoadingSpinner({
  className,
  ref,
}: {
  className?: string;
  ref?: React.Ref<HTMLDivElement>;
}) {
  return (
    <LoadingPageSpinner
      ref={ref}
      className={className}
      data-testid="checkout-animation"
    />
  );
}
